<template>
    <v-list-item
        :href="document.url ? document.url : null"
        :target="document.url ? '_blank' : null"
        @click="expanded = !expanded"
    >
        <v-list-item-icon>
            <v-icon v-if="document.type === 'supplier'">far fa-external-link</v-icon>
            <v-icon v-else-if="document.embedUrl">far fa-video</v-icon>
            <v-icon v-else-if="!document.fileType && document.url">far fa-external-link</v-icon>
            <v-icon v-else>{{mimeTypeToIcon(document.fileType)}}</v-icon>
        </v-list-item-icon>
        <v-list-item-content v-if="document.video" class="editor-row">
            <v-list-item-title :class="expanded ? 'mt-1 mb-3' : ''">{{document.name}}</v-list-item-title>
            <div v-if="expanded" v-html="document.video"></div>
        </v-list-item-content>
        <v-list-item-content v-else-if="document.embedUrl" class="editor-row">
            <v-list-item-title :class="expanded ? 'mt-1 mb-3' : ''">{{document.name}}</v-list-item-title>
            <div v-if="expanded" class="embed-wrapper">
                <iframe
                    :src="document.embedUrl"
                    :title="document.name"
                    frameborder="0"
                    allow="autoplay; fullscreen; encrypted-media"
                    allowfullscreen
                ></iframe>
            </div>
        </v-list-item-content>
        <v-list-item-content v-else>
            <v-list-item-title>{{document.name}}</v-list-item-title>
        </v-list-item-content>
        <v-list-item-action v-if="document.shareLinkUrl">
            <ShareLinkButton :share-link-url="document.shareLinkUrl" />
        </v-list-item-action>
    </v-list-item>
</template>

<script>
import mimetype2fa from '../../utils/mimeTypeToFontAwesome5';
import ShareLinkButton from './ShareLinkButton.vue';

export default {
    name: "DocumentList",
    components: { ShareLinkButton },
    props: {
        document: {
            type: Object,
        },
    },
    data: () => ({
        expanded: false,
    }),
    methods: {
        mimeTypeToIcon(mimeType) {
            return mimetype2fa(mimeType, {prefix: 'far fa-'});
        },
    },
}
</script>

<style scoped>
.embed-wrapper {
    position: relative;
    width: 100%;
    padding-bottom: 56.25%;
}
.embed-wrapper iframe {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
}
</style>
